import { motion } from "framer-motion";

const CHAPTERS = [
  {
    n: "01",
    title: "Lies den Raum",
    body: "Jedes Gespräch verrät die Wahrheit. Ein Blick, der eine Sekunde zu lange hält, ein Fuß, der zur Tür zeigt, ein Lächeln, das die Augen nie erreicht. Profiling ist keine Magie, es ist trainierte Aufmerksamkeit.",
  },
  {
    n: "02",
    title: "Das Schattenarchiv",
    body: "Was Menschen verbergen, sagt mehr als das, was sie zeigen. Schattenpsyche kartografiert die Kluft zwischen Maske und Motiv: die leise Psychologie, die unter jedem ganz normalen Tag läuft.",
  },
  {
    n: "03",
    title: "Profiling im Alltag",
    body: "Kein Hollywood. Keine Gedankenspiele. Nur beobachtbare Signale, klar erklärt und im echten Leben getestet: im Job, in der Liebe, in der Schlange beim Bäcker.",
  },
];

export const Manifesto = () => (
  <section id="manifesto" className="relative py-24 lg:py-36 bg-void-soft/40" data-testid="manifesto-section">
    <div className="max-w-7xl mx-auto px-4 sm:px-8 lg:px-12">
      <motion.div
        initial={{ opacity: 0, y: 30 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true }}
        transition={{ duration: 0.7 }}
        className="mb-16 lg:mb-24 flex flex-col sm:flex-row sm:items-end sm:justify-between gap-6"
      >
        <div>
          <p className="font-mono text-xs uppercase tracking-[0.35em] text-slate-400 mb-4">
            Manifest
          </p>
          <h2 className="font-cinzel text-3xl sm:text-4xl lg:text-6xl font-bold text-white tracking-tight">
            Warum der Schatten
            <br />
            Tagebuch führt
          </h2>
        </div>
        <p className="font-hand text-2xl text-slate-300 rotate-[-2deg]">
          Feldnotizen des Autors
        </p>
      </motion.div>

      <div className="space-y-0">
        {CHAPTERS.map((c, i) => (
          <motion.div
            key={c.n}
            initial={{ opacity: 0, y: 40 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, margin: "-60px" }}
            transition={{ duration: 0.8, delay: i * 0.1 }}
            className="grid grid-cols-1 lg:grid-cols-12 gap-6 lg:gap-10 items-start py-12 lg:py-16 border-t border-white/10 group"
            data-testid={`manifesto-chapter-item-${c.n}`}
          >
            <div className="lg:col-span-3">
              <span className="font-cinzel text-7xl lg:text-8xl font-bold text-outline group-hover:text-outline-cyan transition-all duration-500">
                {c.n}
              </span>
            </div>
            <div className="lg:col-span-4">
              <h3 className="font-typewriter text-2xl lg:text-3xl text-paper tracking-wide">
                {c.title}
              </h3>
            </div>
            <div className="lg:col-span-5">
              <p className="text-base sm:text-lg leading-relaxed text-slate-400">{c.body}</p>
            </div>
          </motion.div>
        ))}
      </div>

      <motion.div
        initial={{ opacity: 0, y: 30 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true }}
        transition={{ duration: 0.7 }}
        className="mt-16 lg:mt-20 text-center"
        data-testid="manifesto-cta-block"
      >
        <p className="font-typewriter text-xl sm:text-2xl text-paper mb-7">
          Bereit, Menschen zu lesen?
        </p>
        <a
          href="#books"
          data-testid="manifesto-cta"
          className="glow-btn !text-base !px-10 !py-5 min-h-[56px]"
        >
          Jetzt Buch sichern · 19,99 €
        </a>
      </motion.div>
    </div>
  </section>
);
